export default {
  props: {
    links: [
      { label: "Knowledge Hub", url: "#" },
      { label: "Data Science", url: "#" }
    ]
  }
}
